import { useQuery } from '@tanstack/react-query';
import { fetchShipmentOriginators } from '../../data-provider/select-options';

export const useGetShipmentOriginators = (customerKey: number) => {
  return useQuery({
    // TODO: it is currently depends on x-company-id header. ask back-end to add this param to the payload
    // to make this dependency more explicit
    queryKey: ['shipment-originators', customerKey],
    queryFn: () => fetchShipmentOriginators(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
